"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgQuestionSolid24 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "none", d: "M0 0h24v24H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "M12 4.8c-3.97 0-7.2 3.23-7.2 7.2s3.23 7.2 7.2 7.2 7.2-3.23 7.2-7.2-3.23-7.2-7.2-7.2Zm-.3 11.4a.9.9 0 1 1 0-1.8.9.9 0 0 1 0 1.8Zm2.587-5.324c-.186.297-.538.63-1.058 1.002-.84.621-.817.76-.817 1.322h-1.475c0-.44-.01-.778.228-1.189.152-.263.43-.543.835-.84.485-.346.957-.68.957-1.263 0-.545-.467-.74-1.012-.74-.556 0-1.19.182-1.903.546l-.606-1.218c1.294-.725 3.336-1.054 4.453-.145.82.668.824 1.842.398 2.525Z", fill: "currentColor" })] })) }))); };
exports.default = SvgQuestionSolid24;
